import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=cf09c3b2&scoped=true"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"
import style0 from "./multiple.vue?vue&type=style&index=0&id=cf09c3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf09c3b2",
  null
  
)

export default component.exports